import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Button } from 'shared/ui/button'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { InputWithLabel } from 'shared/ui/input-label'

import s from './styles.module.scss'

interface Props {
  error?: string
  isLoading?: boolean
  onBookCheckTicket?: (promoCode: string) => void
}

export const PromoCode = ({ error, onBookCheckTicket, isLoading }: Props) => {
  const { t } = useTranslation()

  const { closeDialog } = useDialogBottomSheet()

  const [promoCode, setPromoCode] = useState<string>()

  const onBookOrderWithPromo = () => {
    if (!promoCode?.length) return

    onBookCheckTicket?.(promoCode)
  }

  const errorInput = Boolean(error)
    ? {
        type: 'error',
        message: error,
      }
    : undefined

  return (
    <div className={s.container}>
      <p className={clsx(s.title, 'bold-20')}>{t('title_promocode')}</p>
      <p className={clsx(s.desc, 'regular-14')}>{t('desc_promocode')}</p>

      <div className={s.input}>
        <InputWithLabel
          value={promoCode}
          error={errorInput}
          label={t('promocode')}
          onChange={(event) => setPromoCode(event?.target?.value)}
          rightIcon={
            Boolean(promoCode?.length) ? (
              <AppIcon
                width={22}
                height={22}
                className={s.icon}
                id={AllIcons.CROSS_BOLD}
                onClick={() => setPromoCode('')}
              />
            ) : undefined
          }
        />
      </div>

      <div className={s.wrapperButton}>
        <Button
          loading={isLoading}
          onClick={onBookOrderWithPromo}
        >
          <span className="bold-17">{t('on_active')}</span>
        </Button>
        <Button
          disabled={isLoading}
          onClick={closeDialog}
          variant="transparentBlue"
        >
          <span className="bold-17">{t('close')}</span>
        </Button>
      </div>
    </div>
  )
}
